import Backbone from 'backbone'
import WsAuthenticationType from 'scoreboard/admin/model/ws-authentication-type'
const { OAUTH_V2 } = WsAuthenticationType
import WsConstants from 'scoreboard/admin/model/ws-constants'
const {
	CLIENT_ASSERTION_PLACEHOLDER, WS_VENDOR_TYPE
} = WsConstants
import constants from 'scoreboard/components/constants'
const {WEB_SERVICE, REST, POST, HTTP_HEADERS, CONTENT_TYPES} = constants
import {
	encodeUrlParametersFromObject, encodeHttpRequestHeadersFromObject
} from 'scoreboard/components/http-utils'

const Connection = Backbone.Model.extend({

	section: 'admin',

	urlRoot: 'api/admin/import-connections'

})

// see: https://docs.oracle.com/en/cloud/saas/netsuite/ns-online-help/section_162755359851.html
const netSuiteDefaultParams = {
	grant_type: 'client_credentials',
	client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
	client_assertion: CLIENT_ASSERTION_PLACEHOLDER
}

function getDefaultOracleNetSuiteConnection() {
	return new Connection({
		type: WEB_SERVICE,
		wsType: REST,
		wsAuthenticationType: OAUTH_V2,
		wsVendorType: WS_VENDOR_TYPE.ORACLE_NETSUITE,
		accessTokenHttpMethod: POST,
		accessTokenEndpointHttpHeaders: encodeHttpRequestHeadersFromObject({
			[HTTP_HEADERS.CONTENT_TYPE]: CONTENT_TYPES.APPLICATION_X_WWW_FORM_URLENCODED
		}),
		accessTokenEndpointRequestBody: encodeUrlParametersFromObject(netSuiteDefaultParams)
	})
}

export default Connection
export { getDefaultOracleNetSuiteConnection }

Connection.__filename__ = 'admin/connections/connection.js'
